export default __webpack_public_path__ + "media/images/user_photos/136-2965cadc576139057ae9c7827cf10eb0.jpg";